import React from 'react';
import './Logo3D.css';

export const Logo3DAnimated = ({ size = 'normal', className = '' }) => {
  const sizeClasses = {
    small: 'h-16 w-16 sm:h-20 sm:w-20',
    normal: 'h-20 w-20 sm:h-24 sm:w-24 md:h-28 md:w-28 lg:h-32 lg:w-32',
    large: 'h-32 w-32 sm:h-40 sm:w-40 md:h-48 md:w-48 lg:h-56 lg:w-56'
  };

  const containerClass = size === 'large' ? 'logo-3d-container logo-3d-large' : 'logo-3d-container';

  return (
    <div className={`${containerClass} ${className}`}>
      <img 
        src="/jenma-logo-3d.png" 
        alt="JENMA Logo 3D" 
        className={`logo-3d-image ${sizeClasses[size]} object-contain`}
      />
    </div>
  );
};
